import type { EChartsOption } from 'echarts';
import {
  NEBALKON_ECHARTS_COLORS,
  NEBALKON_ECHARTS_SERIES_COLORS,
} from './nebalkon-echarts-colors';

const axisLineColor = NEBALKON_ECHARTS_COLORS.midnightBlueEasy;
const splitLineColor = NEBALKON_ECHARTS_COLORS.arcticMistEasy;
const axisLabelColor = NEBALKON_ECHARTS_COLORS.midnightBlueMedium;

/** Custom ECharts theme for Nebalkon staff dashboard. */
export const nebalkonEchartsTheme: EChartsOption = {
  color: [...NEBALKON_ECHARTS_SERIES_COLORS],
  backgroundColor: 'transparent',
  textStyle: {
    fontFamily: 'Raleway, sans-serif',
    color: NEBALKON_ECHARTS_COLORS.midnightBlue,
    fontSize: 13,
  },
  title: {
    textStyle: {
      color: NEBALKON_ECHARTS_COLORS.midnightBlue,
      fontWeight: 600,
      fontSize: 15,
    },
    subtextStyle: {
      color: NEBALKON_ECHARTS_COLORS.midnightBlueMedium,
      fontSize: 12,
    },
  },
  legend: {
    textStyle: {
      color: NEBALKON_ECHARTS_COLORS.midnightBlue,
      fontSize: 12,
    },
    pageTextStyle: {
      color: NEBALKON_ECHARTS_COLORS.midnightBlueMedium,
    },
  },
  tooltip: {
    backgroundColor: NEBALKON_ECHARTS_COLORS.white,
    borderColor: NEBALKON_ECHARTS_COLORS.arcticMist,
    borderWidth: 1,
    textStyle: {
      color: NEBALKON_ECHARTS_COLORS.midnightBlue,
      fontSize: 13,
    },
    extraCssText: 'border-radius: 8px; box-shadow: 0 4px 16px rgba(20, 3, 66, 0.08);',
  },
  grid: {
    left: 12,
    right: 12,
    top: 40,
    bottom: 12,
    containLabel: true,
  },
  categoryAxis: {
    axisLine: {
      lineStyle: { color: axisLineColor },
    },
    axisTick: {
      lineStyle: { color: axisLineColor },
    },
    axisLabel: {
      color: axisLabelColor,
    },
    splitLine: {
      lineStyle: { color: splitLineColor },
    },
  },
  valueAxis: {
    axisLine: {
      lineStyle: { color: axisLineColor },
    },
    axisTick: {
      lineStyle: { color: axisLineColor },
    },
    axisLabel: {
      color: axisLabelColor,
    },
    splitLine: {
      lineStyle: { color: splitLineColor, type: 'dashed' },
    },
  },
  line: {
    smooth: true,
    symbol: 'circle',
    symbolSize: 6,
    lineStyle: {
      width: 2,
    },
    itemStyle: {
      borderWidth: 2,
      borderColor: NEBALKON_ECHARTS_COLORS.white,
    },
    areaStyle: {
      opacity: 0.08,
    },
  },
  bar: {
    barMaxWidth: 40,
    itemStyle: {
      borderRadius: [4, 4, 0, 0],
    },
  },
  pie: {
    itemStyle: {
      borderColor: NEBALKON_ECHARTS_COLORS.creamyWhite,
      borderWidth: 2,
    },
    label: {
      color: NEBALKON_ECHARTS_COLORS.midnightBlue,
    },
    labelLine: {
      lineStyle: {
        color: NEBALKON_ECHARTS_COLORS.midnightBlueEasy,
      },
    },
  },
};
